import "./Loader.css"

function Loader({ size = "medium", className, ...props }) {
  const sizeClass = size === "small" ? "loader-small" : "loader-medium"

  return <div className={`loader ${sizeClass} ${className || ""}`} {...props} />
}

export default Loader

